<template>
  <div class="products-property-edit">
    <div class="products-property-edit__product" v-for="(selection, index) of currentItemsSelectionBuffer">
      <div class="product__select">
        <label :for="`productSelection_${index}`">{{ $t("item") }}</label>
        <select name="productSelectionInput" :id="`productSelection_${index}`" v-model="selection.id"
          @change="updateList(index)" class="select">
          <option :value="item.id" v-for="item of filteredItems" :disabled="item.disabled">{{ $to(item.name) }}</option>
        </select>
      </div>
      <div class="product__property-input">
        <label :for="`productProperty_${index}`">{{ fieldName }}</label>
        <input type="text" v-model="selection[propertyName]" :id="`productProperty_${index}`" class="input" @keyup="updateList(index)">
      </div>
      <div class="icon-container" @click="remove(index)">
        <svgicon src="icon/delete.svg" :height="16" :width="14"></svgicon>
      </div>
    </div>
    <div class="products-property-edit__add" @click="addNewProduct" :class="{ disabled: areAllProductsSeletected }">
      <div class="icon-container">
        <svgicon src="icon/add-circle.svg" :height="16" :width="16"></svgicon>
      </div>
      {{ addText }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductsPropertyEdit",

  props: {
    itemPool: {
      type: Array,
      required: true
    },
    selectedItems: {
      type: Array,
      required: true
    },
    fieldName: {
      type: String,
      required: false
    },
    propertyName: {
      type: String,
      required: true
    },
    propertyFieldType: {
      type: String,
      required: false,
      default: 'text'
    },
    addText: {
      type: String,
      required: false,
      default: 'Add product'
    },
  },

  data() {
    return {
      currentItemsSelectionBuffer: []
    }
  },

  computed: {
    filteredItems() {
      return this.itemPool.map(i => ({ ...i, disabled: this.ignoredItemIds.includes(i.id)}));
    },
    ignoredItemIds() {
      return this.selectedItems.map(i => i.id);
    },
    areAllProductsSeletected() {
      return this.ignoredItemIds.length == this.filteredItems.length;
    }
  },

  watch: {
    'selectedItems': {
      handler(newValue) {
        this.currentItemsSelectionBuffer = newValue || [];
      },
      deep: true
    }
  },

  methods: {
    addNewProduct() {
      if (this.areAllProductsSeletected || this.currentItemsSelectionBuffer.length >= this.itemPool.length) {
        return;
      }
      let newProduct = {id: null };
      newProduct[this.propertyName] = null;
      this.currentItemsSelectionBuffer.push(newProduct);
    },
    remove(index) {
      if (this.selectedItems.length <= index) {
        this.currentItemsSelectionBuffer.splice(index, 1);
        return;
      }
      this.$emit('update', { index: index });
    },
    updateList(index) {
      let product = this.currentItemsSelectionBuffer[index];
      if (!product.id) {
        return;
      }
      this.$emit('update', { product: product, index: index });
    }
  }
}
</script>

<style lang="scss" scoped>
  .products-property-edit {
    display: flex;
    flex-grow: 1;
    flex-wrap: wrap;
    column-gap: 20px;
    row-gap: 20px;

    .products-property-edit__product {
      display: flex;
      max-width: calc(50% - 10px);
      min-width: calc(50% - 10px);
      box-shadow: 0px 1px 2px #0000001F;
      border-radius: 8px;
      flex-grow: 1;
      flex-basis: 0;
      padding: 12px;
      justify-content: space-between;

      .product__select {
        padding-right: 10px;
        flex-grow: 1;
        flex-basis: 20%;

        .select {
          width: 100%;
        }
      }
      .product__property-input {
        padding-right: 10px;
        flex-grow: 1;
        flex-basis: 0;

        .input {
          width: 100%;
        }
        label {
          white-space: nowrap;
        }
      }
      .icon-container {
        align-self: flex-end;
        fill: var(--primary-color);
        padding: 28px 16px 16px;
        cursor: pointer;
      }
    }
    .products-property-edit__add {
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px dashed #E6E6E6;
      border-radius: 8px;
      flex-grow: 1;
      flex-basis: 0;
      max-width: calc(50% - 10px);
      height: 87px;
      cursor: pointer;
      color: var(--primary-color);
      fill: var(--primary-color);
      &.disabled {
        opacity: 0.6;
        pointer-events: none;
      }
    }
    .icon-container {
      padding: 22px 10px;
    }

    @media screen and (max-width: 600px) {
      .products-property-edit__product {
        max-width: 100%;
        min-width: 100%;
        flex-wrap: wrap;
        .product__select, .product__property-input {
          flex-basis: 80%;
        }
        .product__select {
          order: 1;
        }
        .product__property-input {
          order: 3;
          padding-right: 0;
          padding-top: 10px;
        }
        .icon-container {
          order: 2;
          justify-self: flex-end;
        }
      }
      .products-property-edit__add {
        max-width: 100%;
        min-width: 100%;
      }
    }
  }

  @media screen and (max-width: 1300px) {
    .products-property-edit {
      flex-direction: column;

      .products-property-edit__add, .products-property-edit__product {
        width: 100%;
        max-width: none;
      }
    }
  }
</style>